import { reactive } from 'vue'

const DEFAULT_TIMEZONE = 'America/New_York'

const state = reactive({
  timezone: DEFAULT_TIMEZONE,
  loaded: false
})

/** 拉取后台站点时区；前台展示统一按站点时区 */
export async function loadTimezone() {
  if (state.loaded) return
  try {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || ''
    const res = await fetch(`${baseUrl}/api/system/config`)
    const json = await res.json()
    if (json?.data?.system?.timezone) {
      state.timezone = json.data.system.timezone
    }
  } catch (e) {
    console.warn('[timezone] Failed to load site timezone:', e.message)
  }
  state.loaded = true
}

export function getSiteTimezone() {
  return state.timezone || DEFAULT_TIMEZONE
}

/** 前台展示统一用站点时区 */
export function getDisplayTimezone() {
  return getSiteTimezone()
}

function withSiteTimezone(options = {}) {
  const opts = { ...options }
  opts.timeZone = getDisplayTimezone()
  return opts
}

export function formatDateTime(dateStr, locale, options = {}) {
  if (!dateStr) return '-'
  const date = new Date(dateStr)
  if (Number.isNaN(date.getTime())) return '-'
  const lang = locale || 'en'
  const defaults = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }
  return date.toLocaleString(lang, withSiteTimezone({ ...defaults, ...options }))
}

export function formatDate(dateStr, locale) {
  if (!dateStr) return '-'
  const date = new Date(dateStr)
  if (Number.isNaN(date.getTime())) return '-'
  const lang = locale || 'en'
  return date.toLocaleDateString(lang, withSiteTimezone({
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }))
}

export function formatTime(dateStr, locale) {
  if (!dateStr) return '-'
  const date = new Date(dateStr)
  if (Number.isNaN(date.getTime())) return '-'
  const lang = locale || 'en'
  return date.toLocaleTimeString(lang, withSiteTimezone({
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }))
}

export function formatTimezoneLabel() {
  const tz = getDisplayTimezone()
  try {
    const part = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      timeZoneName: 'short'
    })
      .formatToParts(new Date())
      .find(p => p.type === 'timeZoneName')
    if (part?.value) return part.value
  } catch (_e) { /* ignore */ }
  return tz
}
